import { PageType } from "../../legacy/comedian";
import { getApiClient } from "@punchup/utils/apiRegistry";
import { logException } from "@punchup/sentry";

/**
 * Set the page type for a page (a comedians row) via the internal admin API.
 *
 * Used by internal page-creation/edit tooling. Throws on failure so callers
 * can surface an error toast.
 */
export async function CLIENT_setPageType(
  pageId: string,
  type: PageType
): Promise<void> {
  try {
    await getApiClient().put(`/api/v2/internal/pages/${pageId}/page-type`, {
      type,
    });
  } catch (error) {
    logException(error, {
      tags: {
        action: "CLIENT_setPageType",
      },
    });
    throw error;
  }
}
